import {
  CellTemplate,
  Compatible,
  isAlphaNumericKey,
  keyCodes,
  Uncertain,
  UncertainCompatible,
} from "@silevis/reactgrid";
import { ReactNode } from "react";
import { Styles } from "./Style";
import { getOptionsFormAppPart } from "@lhd/components/CloneApp/fieldUtils";
import { Checkbox } from "antd";
import { CellCustomType } from "../../type";
import { SEPARATE } from "@lhd/components/CloneApp/constants";
import TextTooltip from "@lhd/components/TextToolTip";

export class CheckBoxCellTemplate implements CellTemplate<CellCustomType> {
  private isWrapText = false;
  constructor(_isWrapText?: boolean) {
    this.isWrapText = !!_isWrapText;
  }
  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    const uncertainCellAs = uncertainCell as CellCustomType;

    return {
      value: NaN,
      ...uncertainCellAs,
    };
  }

  getClassName(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
  ): string {
    return cell.className || "";
  }

  update(
    cell: Compatible<CellCustomType>,
    cellToMerge: UncertainCompatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({
      ...cell,
      text: cellToMerge.text,
      valueSubmit: cellToMerge.valueSubmit,
    });
  }

  handleKeyDown(
    cell: Compatible<CellCustomType>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<CellCustomType>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode))
      return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode:
        keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }

  render(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void,
  ): ReactNode {
    if (!isInEditMode) {
      if (this.isWrapText) {
        return <div className="whitespace-pre-line">{cell.text}</div>;
      }
      return <TextTooltip>{cell.text}</TextTooltip>;
    }
    const options = getOptionsFormAppPart(cell.appPart);
    return (
      <Styles onPointerDown={(e) => e.stopPropagation()}>
        <Checkbox.Group
          defaultValue={
            Array.isArray(cell.valueSubmit)
              ? cell.valueSubmit
              : typeof cell.valueSubmit === "string"
              ? cell.valueSubmit.split(SEPARATE)
              : []
          }
          options={options}
          onChange={(values) => {
            const updatedCell = this.getCompatibleCell({
              ...cell,
              valueSubmit: values.join(SEPARATE),
            });

            onCellChanged(updatedCell, false);
          }}
        />
      </Styles>
    );
  }
}
